import { render } from "./courseInfoQb.vue?vue&type=template&id=6e16edba&scoped=true"
import script from "./courseInfoQb.vue?vue&type=script&lang=js"
export * from "./courseInfoQb.vue?vue&type=script&lang=js"

import "./courseInfoQb.vue?vue&type=style&index=0&id=6e16edba&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e16edba"]])

export default __exports__